import {
  Checkbox,
  Input,
  RadioButton,
  Typography,
  PrimaryButton,
  SecondaryButton,
} from '@weareopenr/component-library';
import styles from './ScheduleView.module.scss';
import { publishTimes } from './shared';
import { IPublishFormValues, Steps } from '../ProductPublishModal/types';

import { useForm, UseFormRegister, UseFormWatch } from 'react-hook-form';
import { ButtonContainer } from '../ButtonContainer/ButtonContainer';
import dayjs from 'dayjs';
import { formatDateTimeDayJs } from '../../helpers/formatDateTime/formatDateTimeDayJs';

export interface PublishScheduleFormValues {
  publicationType: publishTimes;
  publicationDate: string; // string is returned from HTML input
  confirmationCheckbox: boolean;
}

export const ScheduleView = ({
  submitDataToParent,
  defaultPublicationDate,
}: {
  submitDataToParent: (data: Partial<IPublishFormValues>, nextStep?: number) => void;
  defaultPublicationDate: Date | null;
}) => {
  const {
    watch,
    register,
    handleSubmit,
    formState: { isValid },
  } = useForm<PublishScheduleFormValues>({
    defaultValues: {
      publicationType: defaultPublicationDate ? publishTimes.SCHEDULE : publishTimes.NOW,
      publicationDate: dayjs(defaultPublicationDate).format('YYYY-MM-DDTHH:mm') || '',
      confirmationCheckbox: false,
    },
  });

  const onSubmit = (data: PublishScheduleFormValues) => {
    submitDataToParent(
      {
        publicationDate: data.publicationType === publishTimes.SCHEDULE ? new Date(data.publicationDate) : null,
      },
      Steps.summary,
    );
  };
  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <ScheduleSelector register={register} watch={watch} />
      <ButtonContainer
        left={
          <SecondaryButton
            onClick={() => {
              submitDataToParent({}, Steps.excludeProducts);
            }}
            size="full-width"
          >
            Back
          </SecondaryButton>
        }
        right={
          <PrimaryButton type="submit" size="full-width" disabled={!isValid}>
            Continue
          </PrimaryButton>
        }
      />
    </form>
  );
};

export const ScheduleSelector = ({ register, watch }: { register: UseFormRegister<any>; watch: UseFormWatch<any> }) => {
  const watchPublishType = watch('publicationType');
  return (
    <>
      <Typography weight="semi-bold" size="xxlarge" className={styles['subheader']}>
        Publish date & time
      </Typography>
      <div className={styles['radio-container']}>
        <RadioButton name="publicationType" register={register} value={publishTimes.NOW}>
          Publish now
        </RadioButton>
        <RadioButton name="publicationType" register={register} value={publishTimes.SCHEDULE}>
          Schedule publish for future
        </RadioButton>
        {watchPublishType === publishTimes.SCHEDULE && (
          <div className={styles['schedule-container']}>
            <Input
              type="datetime-local"
              label="Date time"
              register={register('publicationDate', {
                required: 'Publication date is required',
                validate: (value: string) => {
                  if (!value) {
                    return 'Publication date is required';
                  }
                  return dayjs(value).isAfter(dayjs()) || 'Publication date must be in the future';
                },
              })}
            />
            <Checkbox
              labelWeight="regular"
              name="confirmationCheckbox"
              register={register}
              required
              label={`I acknowledge that this publish will use a snapshot of the selected data as of ${formatDateTimeDayJs(new Date())}. Changes made after this time will require a new publish.`}
            />
          </div>
        )}
      </div>
    </>
  );
};
